const module = { name: 'theater/details/shared/tdp.showModals', exports: {} }; const exports = module.exports;



import { Fandango as Fandango_context } from 'require-core';

const { context: { device: { isMobile } } } = Fandango_context;


import { Fandango_eventQueue as eventQueue } from 'require-global';



const { EventNames } = eventQueue


import { default as nonTicketingPopup } from 'swug-fdRequire-call:theater/details/shared/nonTicketingPopup';

function initDomainRedirectModal() {
    const modal = document.querySelector('.js-domain-redirect-modal');
    if (!modal) {
        return;
    }
    modal.removeAttribute('open');
    modal.showModal();
    modal.addEventListener('cancel', event => event.preventDefault());
    modal.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            event.preventDefault();
        }
    });
    modal.querySelector('.js-domainRedirectModal-backBtn')?.addEventListener('click', (event) => {
        if (history.length > 1) {
            event.preventDefault();
            history.back();
        }
    });
}
function showModals(covidModalStatus) {
    if (covidModalStatus && covidModalStatus.showing) {
        return;
    }
    if (isMobile) {
        nonTicketingPopup.show(!isMobile);
    }
}
module.exports = {
    init() {
        initDomainRedirectModal();
        if (eventQueue.hasFired(EventNames.COVID_OVERLAY)) {
            return showModals();
        }
        eventQueue.on(EventNames.COVID_OVERLAY, showModals);
    }
};
export default module.exports;